import { ToastMessageState } from "./ToastMessage.types";

export const ToastMessageStateDefault: ToastMessageState = {
  messages: [],
  setMessages: () => null,
};
